import { motion } from 'framer-motion';
import { cn } from '../lib/utils';
import { ALL_KEYS } from '../lib/nashville_theory';
import useStore from '../store/useStore';
import { Check } from 'lucide-react';

const KeySelector = ({ className }) => {
  const { selectedKeys, toggleKey } = useStore();

  // Group keys by type
  const sharpKeys = ALL_KEYS.filter(k => !k.name.includes('b') || k.name === 'B');
  const flatKeys = ALL_KEYS.filter(k => k.name.includes('b') && k.name !== 'B');

  const KeyButton = ({ keyInfo }) => {
    const isSelected = selectedKeys.includes(keyInfo.name);
    
    return (
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => toggleKey(keyInfo.name)}
        className={cn(
          "relative h-14 w-14 rounded-xl font-mono text-lg font-bold",
          "border-2 transition-colors duration-200",
          isSelected
            ? "bg-foreground text-background border-foreground"
            : "bg-card text-foreground border-border hover:border-foreground/50"
        )}
        data-testid={`key-btn-${keyInfo.name}`}
      >
        {keyInfo.name}
        {isSelected && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            className="absolute -top-1 -right-1 w-5 h-5 bg-accent rounded-full flex items-center justify-center"
          >
            <Check className="w-3 h-3 text-white" />
          </motion.div>
        )}
      </motion.button>
    );
  };

  return (
    <div className={cn("space-y-6", className)} data-testid="key-selector">
      {/* Sharp keys (Circle of 5ths right side) */}
      <div>
        <h4 className="text-sm text-muted-foreground uppercase tracking-widest mb-3">
          Sharp Keys
        </h4>
        <div className="flex flex-wrap gap-2">
          {sharpKeys.map(key => (
            <KeyButton key={key.name} keyInfo={key} />
          ))}
        </div>
      </div>

      {/* Flat keys (Circle of 5ths left side) */}
      <div>
        <h4 className="text-sm text-muted-foreground uppercase tracking-widest mb-3">
          Flat Keys
        </h4>
        <div className="flex flex-wrap gap-2">
          {flatKeys.map(key => (
            <KeyButton key={key.name} keyInfo={key} />
          ))}
        </div>
      </div>

      <div className="text-sm text-muted-foreground">
        {selectedKeys.length} key{selectedKeys.length !== 1 ? 's' : ''} selected
      </div>
    </div>
  );
};

export default KeySelector;
